import { types, actions } from './requests'
export const GETPRODUCTION_TYPES = {
    ...types('GETPRODUCTION'),
}
export const GETPRODUCTION_ACTIONS = {
    ...actions('GETPRODUCTION'),
}